import { InjectBrandFavicons, Layout } from "@dgs/core";
import { ErrorBoundary } from "@sentry/react";
import { FC } from "react";
import { Outlet } from "react-router";
import { createGlobalStyle } from "styled-components";
import { useScrollRestoration } from "../../../shared/useScrollRestoration";
import { PMApplicationBar } from "./PMApplicationBar";
import { PMNavBar } from "./PMNavBar";
import { Footer } from "./region/Footer";
import { useConfig } from "./shared/hooks/useConfig";
import { ErrorPage } from "./shared/ui/ErrorPage";

const GlobalStyles = createGlobalStyle`
  html, body {
    font-size: ${({ theme }) => theme.fonts.sizes.normal};
  }
  ${({ theme }) => theme.global};
`;

const FrontendFavicons: FC = () => {
	const { brand } = useConfig();

	return <InjectBrandFavicons brand={brand} />;
};

export const Content: FC = () => {
	useScrollRestoration();

	return (
		<>
			<GlobalStyles />
			<FrontendFavicons />
			<Layout
				header={<PMApplicationBar />}
				navigation={<PMNavBar />}
				content={
					<ErrorBoundary fallback={<ErrorPage />}>
						<Outlet />
					</ErrorBoundary>
				}
				footer={<Footer />}
			/>
		</>
	);
};
